import "./src/pages/style.css"